const INVITATION_LOGIN_RETURN_KEY = 'invitation-login-return';

export const persistInvitationLoginReturn = (search: string): void => {
  try {
    sessionStorage.setItem(
      INVITATION_LOGIN_RETURN_KEY,
      search.startsWith('?') ? search : `?${search}`,
    );
  } catch {
    return;
  }
};

const getInvitationLoginReturnRoute = (): string | undefined => {
  try {
    const storedSearch = sessionStorage.getItem(INVITATION_LOGIN_RETURN_KEY);
    if (!storedSearch) {
      return undefined;
    }

    return `/invitation${
      storedSearch.startsWith('?') ? storedSearch : `?${storedSearch}`
    }`;
  } catch {
    return undefined;
  }
};

export const clearInvitationLoginReturn = (): void => {
  try {
    sessionStorage.removeItem(INVITATION_LOGIN_RETURN_KEY);
  } catch {
    return;
  }
};

export const consumeInvitationLoginReturnRoute = (): string | undefined => {
  const route = getInvitationLoginReturnRoute();
  clearInvitationLoginReturn();
  return route;
};
